
import React from 'react';
import Header from '@/components/Header';
import PageAccessControl from '@/components/admin/PageAccessControl';

const PageAccessControlPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header useBackButton={true} pageName="Page Access Control" />
      
      <div className="container py-8 pt-[64px]">
        <div className="max-w-4xl mx-auto">
          <div className="mb-6">
            <h1 className="text-3xl font-bold mb-2">Page Access Control</h1>
            <p className="text-muted-foreground">
              Control which sections are accessible to non-admin users
            </p>
          </div>
          
          <PageAccessControl />
        </div>
      </div>
    </div>
  );
};

export default PageAccessControlPage;
